interface HomeTabProps {
  onShowCreateBand: () => void;
  onShowCreateRecruitment: () => void;
  onShowBandDetail: (bandName: string) => void;
}

const HomeTab = ({
  onShowCreateBand,
  onShowCreateRecruitment,
  onShowBandDetail,
}: HomeTabProps) => {
  return (
    <div>
      {/* Search Filters */}
      <div className="bg-white rounded-xl p-4 shadow-sm mb-6">
        <h2 className="font-semibold mb-4">🔍 検索・フィルター</h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              ジャンル
            </label>
            <select className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              <option>すべて</option>
              <option>ロック</option>
              <option>ポップス</option>
              <option>ジャズ</option>
              <option>メタル</option>
              <option>フォーク</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              エリア
            </label>
            <select className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              <option>すべて</option>
              <option>東京都</option>
              <option>大阪府</option>
              <option>神奈川県</option>
              <option>愛知県</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              募集ポジション
            </label>
            <div className="flex flex-wrap gap-2">
              {["ボーカル", "ギター", "ベース", "ドラム", "キーボード"].map(
                (position) => (
                  <button
                    key={position}
                    className="px-3 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm hover:bg-blue-100 hover:text-blue-700 transition-colors"
                  >
                    {position}
                  </button>
                )
              )}
            </div>
          </div>
        </div>
        <button className="w-full mt-4 gradient-bg text-white py-3 rounded-lg font-medium hover:opacity-90 transition-opacity">
          検索する
        </button>
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-2 gap-4 mb-6">
        <button
          onClick={onShowCreateBand}
          className="gradient-bg text-white p-6 rounded-xl shadow-lg card-hover"
        >
          <div className="text-3xl mb-2">🎸</div>
          <div className="font-semibold">バンド作成</div>
          <div className="text-sm opacity-90">新しいバンドを作ろう</div>
        </button>
        <button
          onClick={onShowCreateRecruitment}
          className="bg-orange-500 text-white p-6 rounded-xl shadow-lg card-hover"
        >
          <div className="text-3xl mb-2">📢</div>
          <div className="font-semibold">メンバー募集</div>
          <div className="text-sm opacity-90">募集を投稿する</div>
        </button>
      </div>

      {/* Search Results & Recent Recruitments */}
      <div className="space-y-4 mb-6">
        <h3 className="font-semibold">検索結果・最新の募集 (12件)</h3>
        <div
          className="bg-white rounded-xl p-4 shadow-sm card-hover cursor-pointer"
          onClick={() => onShowBandDetail("The Rockers")}
        >
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full flex items-center justify-center text-white font-bold mr-3">
                TR
              </div>
              <div>
                <h3 className="font-semibold">The Rockers</h3>
                <p className="text-sm text-gray-600">ロック • 東京都 • 5人</p>
              </div>
            </div>
            <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded-full">
              ドラム募集
            </span>
          </div>
          <p className="text-sm text-gray-700 mb-3">
            本格的なロックバンドです。ライブ経験豊富なメンバーと一緒に活動しませんか？
          </p>
          <div className="flex items-center justify-between">
            <div className="flex items-center text-xs text-gray-500">
              <span className="mr-3">📅 週2回</span>
              <span className="mr-3">🎯 中級者以上</span>
              <span>💰 月5000円</span>
            </div>
            <button className="bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-600 transition-colors">
              詳細を見る
            </button>
          </div>
        </div>

        {/* Recent Recruitments */}
        <div className="mb-6">
          <div className="space-y-4">
            <div className="bg-white rounded-xl p-4 shadow-sm card-hover">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <h3 className="font-semibold text-gray-800">
                    Jazz Collective
                  </h3>
                  <p className="text-sm text-gray-600">ジャズ • 大阪府</p>
                </div>
                <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                  ベース募集
                </span>
              </div>
              <p className="text-sm text-gray-700 mb-3">
                本格的なジャズセッションを楽しみたい方募集。経験者優遇です。
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center text-xs text-gray-500">
                  <span className="mr-3">📅 月2-3回</span>
                  <span>🎯 経験者優遇</span>
                </div>
                <button className="bg-blue-500 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-600 transition-colors">
                  応募する
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeTab;
